



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { Inject } from 'vue-typedi';
import { OrderService } from '@/services/OrderService';
import HistoryFilterPanel from '@/components/history/HistoryFilterPanel.vue';
import { HistoryFilterRequest } from '@/model/history/HistoryFilterRequest';
import { EventBus } from '@/helpers/EventBus';
import { StoreService } from '@/services/StoreService';
import { Zone } from '@/model/Zone';
import {Drive} from "@/model/Drive";

@Component({
  components: {HistoryFilterPanel}
})
export default class HistorySearchForm extends Vue {

    @Inject()
    orderService!: OrderService;

    @Inject()
    storeService!: StoreService;

    @Prop({default: {}}) filters: HistoryFilterRequest;
    @Watch('filters') watchFilters() { this.updateCurrentSearchTerm(this.filters); }

    private isFilterPanelDisplayed: boolean = false;
    private searchTerms: string = '';
    private allZones: Zone[] = [];

    private isSearchTermChangeEventEnabled: boolean = true;

    created() {
        this.storeService.getStoreById().then(store => this.allZones = store.zones);
    }

    onSearchTermsChange() {
        if (!this.isSearchTermChangeEventEnabled) {
            return;
        }

        EventBus.$emit(EventBus.HISTORY_SEARCH_TERMS_CHANGE, this.searchTerms);
    }

    toggleFilterPanel() {
        this.isFilterPanelDisplayed = !this.isFilterPanelDisplayed;
    }

    private updateCurrentSearchTerm(filters: HistoryFilterRequest) {
        if (!filters || !filters.searchTerms) {
            return;
        }

        this.isSearchTermChangeEventEnabled = false;

        const newSearchTerms = filters.searchTerms;
        if (newSearchTerms !== this.searchTerms) {
            this.searchTerms = newSearchTerms;
        }

        this.isSearchTermChangeEventEnabled = true;
    }

    get storeDrives(): Drive[] {
      const storeDrives = sessionStorage.getItem("storeDrives");
      if (storeDrives == null || storeDrives.length <= 1) {
        return [];
      }
      return JSON.parse(storeDrives);
    }
}
